import { useClose } from '../../../shared/native-modules/core/useClose';
import { logTapButton } from '../../../shared/native-modules/tare/logTapButton';

import { useCallback } from 'react';

/**
 * Hook that returns a function to close ViewJob with logging.
 * This wraps the generic useClose hook with ViewJob-specific logging.
 */
export function useCloseVJ(): () => void {
    const close = useClose();

    return useCallback(() => {
        void close();
        void logTapButton('rn-view-job-bottom-sheet', 'close');
    }, [close]);
}
